function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PauseCircleSmall = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M6.33329 4.66663C6.70148 4.66663 6.99996 4.9651 6.99996 5.33329V10.6666C6.99996 11.0348 6.70148 11.3333 6.33329 11.3333C5.9651 11.3333 5.66663 11.0348 5.66663 10.6666V5.33329C5.66663 4.9651 5.9651 4.66663 6.33329 4.66663Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.66663 4.66663C10.0348 4.66663 10.3333 4.9651 10.3333 5.33329V10.6666C10.3333 11.0348 10.0348 11.3333 9.66663 11.3333C9.29844 11.3333 8.99996 11.0348 8.99996 10.6666V5.33329C8.99996 4.9651 9.29844 4.66663 9.66663 4.66663Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.666626C3.94987 0.666626 0.666626 3.94987 0.666626 7.99996C0.666626 12.05 3.94987 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.05 15.3333 7.99996C15.3333 3.94987 12.05 0.666626 7.99996 0.666626ZM1.99996 7.99996C1.99996 4.68625 4.68625 1.99996 7.99996 1.99996C11.3137 1.99996 14 4.68625 14 7.99996C14 11.3137 11.3137 14 7.99996 14C4.68625 14 1.99996 11.3137 1.99996 7.99996Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_10678_566722",
      children: /*#__PURE__*/_jsx("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })
  })]
}));
//# sourceMappingURL=PauseCircleSmall.js.map